import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/client.tsx");
